/* export const apiUrl= process.env.REACT_APP_API_URL; */
export const apiUrl = "https://dramadelincalzadillaapi.rocazit.com";
//export const apiUrl = "http://localhost:8000";
export const drName = "Dr. Madelin Calzadilla";
export const specificConfigurationDataUrl =
  apiUrl + "/api/v1/configuracion/getdoctor";
